import { Box, Button, Grid, Typography } from "@mui/material";
import SubHeaderTwo from "../../app/layout/SubHeaderTwo";
import HorizontalStepper from "../../app/common/HorizontalStepper";
import Books from "./Books";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import agent from "../../app/api/agent";

export default function CDABook() {
  const steps = [
    "Purchase the CDA Competency Standards Book",
    "Select your Credential Type",
    "Watch the How-to Video",
  ];
  const CDAStandards =
    "The CDA Competency Standards book includes the documents and instructions required to prepare your portfolio.";
  const purchase =
    "You must first purchase your setting-specific CDA Competency Standards book.";
  const notpurchased = `If you have not yet purchased the CDA Competency Standards book ($25) for your type of program setting (infant-toddler, preschool, family child care, or home visitor), click the "Visit Council Store" button to purchase your book from the Council website now.`;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const data = await agent.Account.currentUser();
      if (data.welcomeComplete === true) navigate("/myprogresssummary");
    };
    fetchData();
  }, []);

  const handleClick = () => {
    navigate("/welcome/credential");
  };

  return (
    <Box>
      <SubHeaderTwo title="Welcome > How to Get Started" />
      <Grid container>
        <HorizontalStepper activeStep={0} steps={steps} />
        <Grid item xs={12} md={7} sx={{ order: { xs: 2, md: 1 } }}>
          <Typography sx={{ fontWeight: "bold" }}>{CDAStandards}</Typography>
          <Typography sx={{ fontWeight: "bold" }} mt={2}>
            {purchase}
          </Typography>
          <Typography>{notpurchased}</Typography>

          <Button
            href="https://yourcouncil.org/cfprssa/ecssashop.show_category?p_category_id=CDA_COMP_BOOKS"
            target="_blank"
            variant="contained"
            color="secondary"
            sx={{ textTransform: "none", mb: 3, mt: 4 }}
          >
            Visit the Council Store
          </Button>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Button
                  onClick={handleClick}
                  variant="contained"
                  sx={{ textTransform: "none", mb: 3 }}
                >
                  Next Step
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            justifyContent: "center",
            order: { xs: 1, md: 2 },
          }}
        >
          <Books />
        </Grid>
      </Grid>
    </Box>
  );
}
